import { useEffect } from 'react';
import { getConfig } from '../util/config';

export function usePageUrl(urlPattern, params) {
    useEffect(() => {
        let url = urlPattern;
        if (params?.prospect) {
            url = url.replace('{prospectId}', params.prospect.get('id'));
        }
        try {
            url = url + window.location.search;
        } catch (e) {
            // meh
        }
        getConfig().onPageChanged(url);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlPattern]);
}
